import React from 'react';
import { IconProps } from '../../Interfaces/Props';

const IconAccept = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size ?? '18'}
      height={props.size ?? '18'}
      viewBox="0 0 24 24"
      className={props.className}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M11 20h-.5c-3.759 0-5.638 0-6.893-.99a4.4 4.4 0 0 1-.554-.523C2 17.307 2 15.537 2 12s0-5.306 1.053-6.487q.253-.284.554-.522C4.862 4 6.741 4 10.5 4h3c3.759 0 5.638 0 6.892.99q.302.24.555.523C21.896 6.577 21.99 8.118 22 11M2 9h20m-8 9s1 0 2 2c0 0 3.177-5 6-6"
        color="currentColor"
      />
    </svg>
  );
};

export default IconAccept;
